import { useState } from 'react';

import { type PublisherFormValues } from '../types';

export const useSelectCustomPublisher = ({
  publisherFormValues,
}: {
  publisherFormValues: PublisherFormValues;
}) => {
  const [selectedCustomPublisher, setSelectedCustomPublisher] = useState<
    string | undefined
  >(() => publisherFormValues.customPublisher);

  return [selectedCustomPublisher, setSelectedCustomPublisher] as const;
};
